// Explanations shown by the info icons on the Marketing Report.
// Counts are recorded by the kiosk (magex_mui2) per session and summed per day.

const SESSION =
  'A session is one customer visit: from tapping the screensaver until the kiosk goes back to the screensaver. One session is counted each time the kiosk returns to the screensaver.';

export const MARKETING_INFO = {
  totalSessions: {
    intro: 'Total number of sessions (customer visits) for the selected dates and machines.',
    items: [{ label: 'Session', text: SESSION }],
  },
  aveSession: {
    intro: 'Average length of a session, in seconds, for the selected dates and machines.',
    items: [{ label: 'Session', text: SESSION }],
  },
  basic: {
    intro: SESSION + ' All numbers are totals for the selected dates and machines.',
    items: [
      { label: 'Session Start', text: 'Number of sessions (customer visits) on the kiosk.' },
      {
        label: 'Session Complete',
        text: 'Sessions where payment went through and the order was sent. Counted even if an item failed to dispense.',
      },
      { label: 'All Product', text: 'Times the “All Products” list was opened.' },
      { label: 'All Brand', text: 'Times the “All Brands” list was opened.' },
      { label: 'Cart Page', text: 'Times the shopping cart was opened.' },
      {
        label: 'Cart Abandonment',
        text: 'Sessions that ended with items still in the cart and no purchase.',
      },
      { label: 'FAQ Page', text: 'Times the FAQ page was opened.' },
      { label: 'Ave Session Time(s)', text: 'Average length of a session, in seconds.' },
      {
        label: 'English / French / Spanish',
        text: 'Times a customer switched the screen to that language.',
      },
    ],
  },
  products: {
    intro: 'How customers interacted with each product on the kiosk.',
    items: [
      { label: 'Added To Cart', text: 'Times this product was added to the cart.' },
      { label: 'Detail Page', text: 'Times the product detail page was opened.' },
      {
        label: 'Specification',
        text: 'Times the “Specifications” tab was viewed on the detail page.',
      },
      {
        label: 'What included',
        text: 'Times the “What’s Included” tab was viewed on the detail page.',
      },
      {
        label: 'Conversion',
        text: 'Units of this product paid for. Includes units that failed to dispense.',
      },
    ],
  },
  categories: {
    intro: 'How often each category was browsed on the kiosk.',
    items: [
      { label: 'Category Page', text: 'Times customers opened this category’s product list.' },
    ],
  },
  brands: {
    intro: 'How often each brand was browsed on the kiosk.',
    items: [{ label: 'Brand Page', text: 'Times customers opened this brand’s product list.' }],
  },
  banners: {
    intro:
      'Screensaver images that link to a product or category. Only these promo banners are tracked.',
    items: [
      { label: 'Screen Saver Title', text: 'Name of the screensaver the banner belongs to.' },
      { label: 'Image File Name', text: 'The banner image.' },
      { label: 'Clicked', text: 'Times customers tapped this banner to start a session.' },
      {
        label: 'Conversion',
        text: 'Sessions started from this banner where the promoted product was paid for. Only banners linked to a product are counted; banners linked to a category always show 0.',
      },
    ],
  },
};
